import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, offeringsService } from '@v2/services';
import type { UpdateOfferingPayload } from '@v2/types';

export const useUpdateOffering = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ partnerId, payload }: { partnerId: string; payload: UpdateOfferingPayload }) =>
      offeringsService.updatePartnerOffering(partnerId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.offerings.partner.all);
      queryClient.invalidateQueries(queryKeys.partners.all);
    },
  });

  const updateOffering = async (
    partnerId: string,
    payload: UpdateOfferingPayload,
  ): Promise<boolean> => {
    try {
      await mutation.mutateAsync({ partnerId, payload });
      return true;
    } catch {
      return false;
    }
  };

  return {
    updateOffering,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useUpdateOffering;
